import { getIsWebview } from "./components/Search/utils/getIsWebView";
import { EHeaderTheme } from "./store/slices/layout";
export var headerDataConverter = function headerDataConverter(_ref) {
  var _data$search;
  var data = _ref.data;
  var isWebView = getIsWebview((_data$search = data.search) === null || _data$search === void 0 ? void 0 : _data$search.cookieDomain);
  return {
    header: {
      common: data,
      menu: {
        activeCategory: data.menu.leftBlock[0]
      },
      layout: {
        isWebView: isWebView,
        theme: data.theme || EHeaderTheme.secondary
      }
    }
  };
};